<template>
  <button
    hidden
    id="notification_toast_button"
    type="button"
    data-bs-toggle="toast"
    data-bs-target="notification_toast"
  ></button>

  <div class="toast-container p-3">
    <div
      id="notification_toast"
      class="toast"
      role="alert"
      aria-live="assertive"
      aria-atomic="true"
    >
      <div class="toast-header">
        <i class="fa-solid fa-check-circle text-primary"></i>
        <Typograph :variant="'label'" class="me-auto ms-2">{{
          title
        }}</Typograph>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="toast"
          aria-label="Close"
        ></button>
      </div>
      <div class="toast-body">
        <Typograph :variant="'label'" class="text-muted">
          {{ message }}
        </Typograph>
      </div>
      <div class="progress progress-sm">
        <div
          ref="toastProgress"
          class="progress-bar progress-animation"
          role="progressbar"
          aria-valuemin="0"
          aria-valuemax="100"
        ></div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { EventBus, EventBusNames } from "@/utils/EventBus";
import { Toast } from "bootstrap";
import { onMounted, ref, useTemplateRef } from "vue";

const title = ref("");
const message = ref("");
const progress = useTemplateRef<any>("toastProgress");

onMounted(() => {
  EventBus.$on(EventBusNames.SHOW_TOAST, (data) => {
    title.value = data.title;
    message.value = data.message;
  });

  const toastTrigger = document.getElementById("notification_toast_button");
  const toast = document.getElementById("notification_toast") as Element;

  if (toastTrigger) {
    const toastBootstrap = Toast.getOrCreateInstance(toast);
    toastTrigger.addEventListener("click", () => toastBootstrap.show());
    progress.value.addEventListener("animationend", () =>
      toastBootstrap.hide()
    );
  }

  // Reset animation
  progress.value.classList.remove("progress-animation");
  void progress.value.offsetWidth; // Trigger reflow
  progress.value.classList.add("progress-animation");
});
</script>

<style>
/* Animação da barra de progresso */
.progress-animation {
  animation: progress 3.5s linear forwards;
}

@keyframes progress {
  from {
    width: 100%;
  }
  to {
    width: 0%;
  }
}

/* Controle da animação quando o toast é fechado */
.toast:not(.show) .progress-bar {
  animation: none;
  width: 100% !important;
}

.toast {
  top: calc(100dvh - 100px) !important;
  left: 20px;
}
</style>
